import React from "react";
import SaveChanges from "../../../components/Atomos/Icons/EditMode/SaveChanges";
import {
  memberModalPrimaryButtonClassName,
  memberModalSecondaryButtonClassName,
} from "../../../components/Moleculas/Profile/memberModalFooterButtonClasses";

type EditMyProfileActionBarProps = {
  onCancel: () => void;
  onSave: () => void | Promise<void>;
  disabled?: boolean;
  saving?: boolean;
};

/**
 * Single primary action for the unified member profile editor (no per-section saves).
 */
const EditMyProfileActionBar: React.FC<EditMyProfileActionBarProps> = ({
  onCancel,
  onSave,
  disabled,
  saving,
}) => {
  return (
    <div className="sticky bottom-0 z-10 flex flex-row flex-wrap items-center justify-end gap-3 border-t border-gray-200 bg-gray-50/95 px-5 py-4 shadow-[0_-4px_16px_-8px_rgba(0,0,0,0.12)] backdrop-blur-sm sm:static sm:shadow-none sm:py-5 md:px-8">
      <button
        type="button"
        className={memberModalSecondaryButtonClassName}
        onClick={onCancel}
        disabled={saving}
      >
        Cancel
      </button>
      <button
        type="button"
        className={`${memberModalPrimaryButtonClassName} min-w-[220px] justify-center`}
        onClick={() => void onSave()}
        disabled={disabled || saving}
      >
        <span>{saving ? "Saving…" : "Update profile"}</span>
        <span className="flex h-5 w-5 shrink-0 items-center justify-center text-white [&_svg]:fill-current">
          <SaveChanges />
        </span>
      </button>
    </div>
  );
};

export default EditMyProfileActionBar;
